/**
 * A/B Test — Single most relevant cart drawer upsell
 * Toggle: body[data-cart-drawer-upsell-ab="true|false"]
 *   - false (Control / Test A): current 3-card recommendation carousel
 *   - true  (Variant / Test B): one complementary product based on cart contents
 */
(function () {
  'use strict';

  if (window.__cartDrawerUpsellAbInit) return;
  window.__cartDrawerUpsellAbInit = true;

  var ATTR = 'data-cart-drawer-upsell-ab';
  var applying = false;
  var refreshTimer = null;

  function isAbEnabled() {
    if (!document.body) return false;
    return document.body.getAttribute(ATTR) === 'true' ||
      document.documentElement.getAttribute(ATTR) === 'true';
  }

  function getRole(handle, title) {
    var key = String(handle || '').toLowerCase() + ' ' + String(title || '').toLowerCase();
    if (key.indexOf('vacuum-kit') > -1 || key.indexOf('vacuum kit') > -1) return 'kit';
    if (key.indexOf('pump') > -1) return 'pump';
    if (key.indexOf('bag') > -1) return 'bag';
    if (key.indexOf('weekender') > -1 || key.indexOf('luggage') > -1 || key.indexOf('suitcase') > -1) return 'luggage';
    if (key.indexOf('scent') > -1 || key.indexOf('sachet') > -1) return 'scent';
    if (String(handle || '').toLowerCase() === 'tag' || key.indexOf('tracker') > -1 || key.indexOf('findmy') > -1 || key.indexOf('find my') > -1) {
      return 'tracker';
    }
    return 'other';
  }

  function getPickOrder(flags) {
    if (flags.bag && !flags.pump && !flags.kit) return ['pump', 'bag', 'tracker', 'scent', 'other'];
    if (flags.pump && !flags.bag && !flags.kit) return ['bag', 'pump', 'tracker', 'scent', 'other'];
    if (flags.luggage && !flags.kit && !flags.bag && !flags.pump) return ['bag', 'pump', 'tracker', 'scent', 'other'];
    if (flags.kit || (flags.bag && flags.pump)) return ['tracker', 'scent', 'pump', 'bag', 'other'];
    if (flags.tracker) return ['scent', 'pump', 'bag', 'tracker', 'other'];
    if (flags.scent) return ['tracker', 'pump', 'bag', 'scent', 'other'];
    return ['pump', 'bag', 'tracker', 'scent', 'other'];
  }

  function getCartFlags() {
    var flags = {
      bag: false,
      pump: false,
      kit: false,
      luggage: false,
      tracker: false,
      scent: false,
      handles: {}
    };

    document.querySelectorAll('cart-drawer line-item').forEach(function (item) {
      var handle = item.getAttribute('data-product-handle') || '';
      var titleEl = item.querySelector('.line-item__info .bold, .line-item__info a, .line-item__info p');
      var title = titleEl ? titleEl.textContent : '';
      var role = getRole(handle, title);
      flags[role] = true;
      if (handle) flags.handles[handle] = true;
    });

    return flags;
  }

  function pickMostRelevant(cards, flags) {
    var available = [];
    var i;
    var card;
    var handle;
    var titleEl;
    var role;

    for (i = 0; i < cards.length; i++) {
      card = cards[i];
      handle = card.getAttribute('data-product-handle') || '';
      if (handle && flags.handles[handle]) continue;

      titleEl = card.querySelector('.pdp_line, .bold');
      role = card.getAttribute('data-upsell-role') || getRole(handle, titleEl ? titleEl.textContent : '');
      if (!card.getAttribute('data-upsell-role')) card.setAttribute('data-upsell-role', role);
      available.push({ card: card, role: role });
    }

    var order = getPickOrder(flags);
    var r;
    var j;

    for (r = 0; r < order.length; r++) {
      for (j = 0; j < available.length; j++) {
        if (available[j].role === order[r]) return available[j].card;
      }
    }

    return available.length ? available[0].card : null;
  }

  function applyTest() {
    if (applying) return;
    applying = true;

    try {
      var enabled = isAbEnabled();
      document.body.classList.toggle('cart-drawer-upsell-ab--active', enabled);

      document.querySelectorAll('cart-drawer .cart-drawer__recommendations').forEach(function (root) {
        var cards = Array.prototype.slice.call(root.querySelectorAll('.horizontal-product'));
        if (!enabled) {
          root.hidden = false;
          cards.forEach(function (card) {
            card.classList.remove('is-most-relevant');
          });
          return;
        }

        var selected = pickMostRelevant(cards, getCartFlags());
        cards.forEach(function (card) {
          card.classList.toggle('is-most-relevant', card === selected);
        });
        root.hidden = !selected;
      });
    } finally {
      applying = false;
    }
  }

  function scheduleApply() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(applyTest, 0);
  }

  function observeDrawer(drawer) {
    if (!drawer || drawer._cartDrawerUpsellObserved) return;
    drawer._cartDrawerUpsellObserved = true;

    new MutationObserver(function () {
      if (applying) return;
      scheduleApply();
    }).observe(drawer, { childList: true, subtree: true });
  }

  function init() {
    applyTest();

    var attrObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === ATTR) applyTest();
      });
    });
    attrObserver.observe(document.body, { attributes: true, attributeFilter: [ATTR] });
    attrObserver.observe(document.documentElement, { attributes: true, attributeFilter: [ATTR] });

    document.querySelectorAll('cart-drawer').forEach(observeDrawer);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('cart-drawer')) {
            observeDrawer(node);
            scheduleApply();
          } else if (node.querySelectorAll) {
            node.querySelectorAll('cart-drawer').forEach(observeDrawer);
          }
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('cart:change', scheduleApply);
    document.addEventListener('cart:refresh', scheduleApply);
    document.addEventListener('variant:add', scheduleApply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.AerlessCartDrawerUpsellAb = {
    refresh: applyTest,
    isEnabled: isAbEnabled
  };
})();
